import { Time } from '../Time';
/**
 * 私有类隐藏ITimer的实现
 */
export class Timer {
    constructor() {
        this._timeInSeconds = 0;
        this._repeats = false;
        this._isDone = false;
        this._elapsedTime = 0;
    }
    getContext() {
        return this.context;
    }
    /**
     * 定时器是否已完成
     */
    get isDone() {
        return this._isDone;
    }
    /**
     * 定时器已运行的时间
     */
    get elapsedTime() {
        return this._elapsedTime;
    }
    reset() {
        this._elapsedTime = 0;
    }
    stop() {
        this._isDone = true;
    }
    tick() {
        // 如果stop在tick之前被调用，那么isDone将为true，我们不应该再做任何事情
        if (!this._isDone && this._elapsedTime > this._timeInSeconds) {
            this._elapsedTime -= this._timeInSeconds;
            this._onTime(this);
            if (!this._isDone && !this._repeats)
                this._isDone = true;
        }
        this._elapsedTime += Time.deltaTime;
        return this._isDone;
    }
    initialize(timeInsSeconds, repeats, context, onTime) {
        this._timeInSeconds = timeInsSeconds;
        this._repeats = repeats;
        this.context = context;
        this._onTime = onTime.bind(context);
    }
    /**
     * 空出对象引用，以便在js需要时GC可以清理它们的引用
     */
    unload() {
        this.context = null;
        this._onTime = null;
    }
}
//# sourceMappingURL=Timer.js.map